import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Modal, Header, Button, Form, Message } from 'semantic-ui-react'
import { setApiKey, setApiKeyModalVisible } from '../actions/commonActions'
import { createHeaders } from '../utils/api'

const ApiKeyModal = ({ showApiKeyModal, dispatch, apiKey }) => {
  const [inputApiKey, setInputApiKey] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async () => {
    if (!inputApiKey.trim()) {
      setError('Please enter an API key')
      return
    }

    setIsLoading(true)
    setError('')

    try {
      const apiUrl = `${process.env.REACT_APP_VALHALLA_URL}/status`
      console.log('Testing API key with URL:', apiUrl)

      console.log('createHeaders:', createHeaders({}, inputApiKey.trim()))
      console.log('inputApiKey.trim():', inputApiKey.trim())
      // Test the API key by making a simple request to the route endpoint
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: createHeaders({}, inputApiKey.trim()),
        body: JSON.stringify({
          costing: 'auto',
          locations: [
            { lat: 40.7486, lon: -73.9864 }, // New York coordinates
            { lat: 40.7486, lon: -73.9864 }, // Same point for testing
          ],
        }),
      })

      console.log('Response status:', response.status)
      console.log('Response ok:', response.ok)

      if (response.ok) {
        dispatch(setApiKey(inputApiKey.trim()))
        // Store in localStorage for persistence
        localStorage.setItem('valhalla_api_key', inputApiKey.trim())
      } else {
        const errorData = await response.json().catch(() => ({}))
        console.log('Error response:', errorData)
        const errorMessage =
          errorData.error ||
          'Invalid API key. Please check your key and try again.'
        setError(errorMessage)
      }
    } catch (err) {
      console.error('API key validation error:', err)
      console.error('Error details:', {
        message: err.message,
        name: err.name,
        stack: err.stack,
      })
      setError(
        'Failed to validate API key. Please check your connection and try again.'
      )
    } finally {
      setIsLoading(false)
    }
  }

  const handleSkip = () => {
    dispatch(setApiKeyModalVisible(false))
  }

  const handleClose = () => {
    if (apiKey) {
      dispatch(setApiKeyModalVisible(false))
    }
  }

  return (
    <Modal
      open={showApiKeyModal}
      onClose={handleClose}
      size="small"
      closeOnDimmerClick={false}
      closeOnEscape={false}
    >
      <Header icon="key" content="API Key Required" />
      <Modal.Content>
        <p>
          This application requires a Geobase API key to function. Please enter
          your API key below.
        </p>

        <Form>
          <Form.Field>
            <label>API Key</label>
            <Form.Input
              type="password"
              placeholder="Enter your Valhalla API key"
              value={inputApiKey}
              onChange={(e, { value }) => setInputApiKey(value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSubmit()
                }
              }}
            />
          </Form.Field>
        </Form>

        {error && (
          <Message negative>
            <Message.Header>Error</Message.Header>
            <p>{error}</p>
          </Message>
        )}

        <Message info>
          <Message.Header>How to get an API key</Message.Header>
          <p>
            You can obtain a Geobase API key by contacting the service provider
            or checking their documentation for API key registration.
          </p>
        </Message>
      </Modal.Content>
      <Modal.Actions>
        <Button basic onClick={handleSkip} disabled={isLoading}>
          Skip for Demo
        </Button>
        <Button
          primary
          onClick={handleSubmit}
          loading={isLoading}
          disabled={!inputApiKey.trim()}
        >
          Save API Key
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

ApiKeyModal.propTypes = {
  showApiKeyModal: PropTypes.bool.isRequired,
  apiKey: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  showApiKeyModal: state.common.showApiKeyModal,
  apiKey: state.common.apiKey,
})

export default connect(mapStateToProps)(ApiKeyModal)
